export const StatusCellRenderer = (props) => {
  const { value } = props;

  if (!value) return null;

  const getStatusColor = (status) => {
    switch(status) {
      case "Onay Bekliyor":
      case "Boşta":
      return "gray";
      case "Onaylandı":
      case "Aktif":
      case "Lisans Üretildi": return "green";
      case "Lisans Yok": return " #1C355E"
      case "Reddedildi":
      case "Pasif":return "#FF1E1E";
      default: return "orange";
    }
  };

  return (
    <div
      style={{
        backgroundColor: getStatusColor(value),
        color: "white",
        padding: "4px 8px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "80%",
        width: "90%"
      }}
    >
      {value}
    </div>
  );
};
